package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AssessmentRatingResponse(
    val data: AssessmentRatingData,
)

@Serializable
data class AssessmentRatingData(
    val id: String = "",
    val rev: String = "",
    val audioPath: String = "",
    val coachName: String = "",
    val domainType: String = "",
    val language: String = "",
    val organization: String = "",
    @SerialName("playerID")
    val playerId: String = "",
    val playerName: String = "",
    val ratedBy: String = "",
    val rating: Double,
    val recordTime: Long = 0,
    val sessionDateTime: String = "",
    @SerialName("sessionID")
    val sessionId: String = "",
    val sessionType: String = "",
    val status: String = "",
    val statusUrl: String = "",
    val type: String = "",
    @SerialName("userID")
    val userId: String = "",
)